import { API_VERSION, HOME_SERVICE, X_API_VERSION } from "../../../constants";
import { apiOptions, apiRequest } from "../../../utils";

const API_HOMES = `${HOME_SERVICE}/attributes`;

export const attributes = {
  getAll: async ({ filters, sort, params, signal, top, skip } = {}) => {
    const options = await apiOptions({
      url: API_HOMES,
      method: "get",
      headers: { [X_API_VERSION]: API_VERSION },
      signal,
      params,
      filters,
      sort,
      top,
      skip,
    });
    return apiRequest(options);
  },
  getById: async ({ id }) => {
    const options = await apiOptions({
      url: `${API_HOMES}/${id}`,
      method: "get",
      headers: { [X_API_VERSION]: API_VERSION },
    });
    return apiRequest(options);
  },
  getAttributesById: async ({ attributeId, categoryId, searchText = "" }) => {
    const options = await apiOptions({
      url: `${API_HOMES}/${attributeId}/values?categoryId=${categoryId}&searchText=${searchText}`,
      method: "get",
      headers: { [X_API_VERSION]: API_VERSION },
    });
    return apiRequest(options);
  },
  create: async ({ data, toastMessageConfig }) => {
    const options = await apiOptions({
      url: API_HOMES,
      headers: { [X_API_VERSION]: API_VERSION },
      method: "post",
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },
  delete: async ({ id, data, toastMessageConfig }) => {
    const options = await apiOptions({
      url: `${API_HOMES}/${id}`,
      method: "delete",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },
  update: async ({ id, data, toastMessageConfig }) => {
    const options = await apiOptions({
      url: `${API_HOMES}/${id}`,
      method: "patch",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },
};
